export default [
  "noStartEnd",
  "end",
  "start",
  "bounds",
  "pageOffset",
  "pageSize",
  "fullDoc",
  "search",
  "topicScores",
  "color",
  "topic",
  "includeFilterCounts",
  "local",
  "varianceFilter",
  "omitGeometry",
  "severityScores",
  "assetTypes",
  "categoriesId",
  "sectors",
  "sectorsId",
];
